import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";
import {IntClipBoardService} from "../../../services/clip-board";
import {catchError, take} from "rxjs/operators";
import {EMPTY} from "rxjs";

@Component({
  selector: 'int-copy-content',
  templateUrl: './int-copy-content.component.html',
  styleUrls: ['./int-copy-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    IntClipBoardService
  ]
})
export class IntCopyContentComponent {

  @Input() content = '';
  @Output() copyEvent = new EventEmitter<boolean>();

  constructor(
    private readonly clipService: IntClipBoardService
  ) {}

  copy() {
    if(this.content) {
      this.clipService.copyToClipboard(this.content)
        .pipe(
          catchError(() => {
            this.copyEvent.next(false);
            return EMPTY;
          }),
          take(1),
        )
        .subscribe(() => {
          this.copyEvent.emit(true)
        });
    }
  }
}
